import React from "react";

export default function NextIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#fff"
        fillOpacity="0.7"
        fillRule="evenodd"
        d="M9 18A9 9 0 109 0a9 9 0 000 18zM8.154 5.646a.5.5 0 10-.708.708L10.093 9l-2.647 2.646a.5.5 0 00.708.708l3-3a.5.5 0 000-.708l-3-3z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}